import React from "react";
import { useTable, List, EditButton, ShowButton, DeleteButton, CreateButton } from "@refinedev/antd";
import { Table, Space } from "antd";
import { TEAM_LIST_QUERY, DELETE_TEAM_MUTATION } from "./queries";

interface ITeam {
  id: string;
  name: string;
  description?: string;
}

export const TeamList: React.FC = () => {
  const { tableProps } = useTable<ITeam>({
    resource: "teams",
    initialPageSize: 10,
    meta: {
      gqlQuery: TEAM_LIST_QUERY,
    },
  });

  return (
    <List
      headerProps={{
        extra: (
          <Space>
            <CreateButton />
          </Space>
        ),
      }}
    >
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="name" title="Name" sorter />
        <Table.Column dataIndex="description" title="Description" />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_text: string, record: ITeam) => (
            <Space>
              <EditButton size="small" recordItemId={record.id} />
              <ShowButton size="small" recordItemId={record.id} />
              <DeleteButton size="small" recordItemId={record.id} meta={{ gqlMutation: DELETE_TEAM_MUTATION}} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};